import { useMutation, useQueryClient } from "@tanstack/react-query";

import { type CreatePostInput, createPost } from "@/adapters/api";
import { useActiveContext } from "@/store/use-active-context";

export function useCreatePost() {
	const queryClient = useQueryClient();
	const activeObraId = useActiveContext((state) => state.activeObraId);

	return useMutation({
		mutationFn: (input: Omit<CreatePostInput, "constructionId">) =>
			createPost({ ...input, constructionId: activeObraId ?? undefined }),
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: ["posts"] });
		},
	});
}
